// Sanitize content name to not collide with sepeartors of Analytics
export const trackedContentName = (name: string) => {
  return name.replaceAll(' - ', '-').replaceAll(' | ', '-');
};
